import React from 'react'
import Layout from './../layout/user/Layout'
import Console from './console/Index'


export default function Landing() {
    return (
        <div>
            <Layout>
                <Console />
            </Layout>
        </div>
    )
}
